module.exports = __webpack_public_path__ + "static/media/showerRect.c8d2a241.png";